// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_bannerDatatableList__RQSqi {
    padding: 30px 30px 0;
}

.banner_bannerHeader__KJ9na {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.banner_imageGroup__vD\\+4q {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
}

.banner_bannerHeader__KJ9na .banner_bannerHeading__oWi\\+n {
    font-size: 20px;
    font-weight: 600;
}

.banner_actionButtonsDeleteAdd__GNniV {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.banner_bannerHeader__KJ9na .banner_leftSide__8lrjJ {
    display: flex;
    gap: 20px;
}

.banner_searchBar__\\+gqle {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 8px;
    min-width: 250px;
    height: 40px;
}

.banner_searchBar__\\+gqle img {
    width: 16px;
    height: 16px;
}

.banner_searchBar__\\+gqle input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #333;
}

.banner_searchBar__\\+gqle input::placeholder {
    color: #999;
}

.banner_addBannerContainer__S2tez {
    padding: 25px 25px 0;
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.banner_bannerGenerateSection__QWJZs {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.banner_bannerInput__te\\+3a {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 6px;
    outline: none;
    line-height: 24px;
}

.banner_description__Cjdnt {
    width: 100%;
    min-height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    resize: vertical;
    margin-top: 10px;
    outline: none;
    font-family: 'CyGrotesk-KeyRegular';
}

.banner_description__Cjdnt::placeholder {
    font-size: 20px;
    color: #999;
}

.banner_inputField__ioiGv {
    display: flex;
    flex-direction: column;
}

.banner_leftSide__8lrjJ {
    display: flex;
    gap: 20px;
}

.banner_deleteSelectedBtn__Pr0fr {
    cursor: pointer;
}

.banner_saveButton__Gq-Rz button {
    width: 71.41px;
    height: 39px;
}

.banner_bannerList__Foz6V {
    height: calc(100vh - 70px);
    overflow: auto;
}

.banner_bannerListHeight__j1p1w {
    height: 100vh;
}

.banner_bannerForm__nT\\+dE {
    padding: 25px;
    max-width: 600px;
}

.banner_bannerForm__nT\\+dE h2 {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
}

.banner_inputField__ioiGv {
    margin-bottom: 20px;
    width: 100%;
}

.banner_inputField__ioiGv label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.banner_imageUploadBox__EYTqn {
    border: 1px solid #ddd;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    background: #fafafa;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 255px;
}

.banner_imageUploadBox__EYTqn.banner_draging__T0n49 {
    opacity: 70%;
}

.banner_newpageImageUpload__J4JY6 {
    width: 100%;
}

.banner_featureImgMiddleContent__WUm7t {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.banner_fileUploadCover_Img__D0eGI {
    width: 48px;
    height: 48px;
    opacity: 0.6;
}

.banner_newPageImageUploadText__UkNof {
    font-size: 14px;
    color: #666;
    margin: 0;
}

.banner_featuredImg__7gZHI {
    max-width: 100%;
    max-height: 200px;
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
}

.banner_progressWrap__NK2ev {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.banner_progress__NnSN- {
    width: 100%;
    height: 4px;
    background: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
}

.banner_color__8k-Qd {
    height: 100%;
    background: #000;
    animation: banner_progress__NnSN- 2s ease-in-out infinite;
}

@keyframes banner_progress__NnSN- {
    0% {
        width: 0%;
    }

    50% {
        width: 50%;
    }

    100% {
        width: 100%;
    }
}

.banner_buttonGroup__zIy\\+s {
    margin-bottom: 20px;
}

.banner_buttonField__NcT3p {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    margin-top: 8px;
}

.banner_buttonField__NcT3p input {
    flex: 1 1;
}

.banner_error__PfFKT {
    color: red;
    font-size: 14px;
}

@media screen and (max-width: 768px) {

    .banner_actionButtonsDeleteAdd__GNniV {
        justify-content: space-between;
        width: 100%;
    }

    .banner_searchBar__\\+gqle,
    .banner_leftSide__8lrjJ {
        width: 100%;
        min-width: 100%;
    }

    .banner_searchBar__\\+gqle,
    .banner_leftSide__8lrjJ {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }

    .banner_buttonField__NcT3p {
        flex-direction: column;
    }

}`, "",{"version":3,"sources":["webpack://./src/Pages/Appearance/Banner/banner.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yDAA2C;AAC/C;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI;QACI,8BAA8B;QAC9B,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;;IAEA;QACI,sBAAsB;IAC1B;;AAEJ","sourcesContent":[".bannerDatatableList {\n    padding: 30px 30px 0;\n}\n\n.bannerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.imageGroup {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 20px;\n}\n\n.bannerHeader .bannerHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.bannerHeader .leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    gap: 8px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n}\n\n.searchBar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n}\n\n.searchBar input::placeholder {\n    color: #999;\n}\n\n.addBannerContainer {\n    padding: 25px 25px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n}\n\n.bannerGenerateSection {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.bannerInput {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    outline: none;\n    line-height: 24px;\n}\n\n.description {\n    width: 100%;\n    min-height: 80px;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    resize: vertical;\n    margin-top: 10px;\n    outline: none;\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.description::placeholder {\n    font-size: 20px;\n    color: #999;\n}\n\n.inputField {\n    display: flex;\n    flex-direction: column;\n}\n\n.leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n}\n\n.saveButton button {\n    width: 71.41px;\n    height: 39px;\n}\n\n.bannerList {\n    height: calc(100vh - 70px);\n    overflow: auto;\n}\n\n.bannerListHeight {\n    height: 100vh;\n}\n\n.bannerForm {\n    padding: 25px;\n    max-width: 600px;\n}\n\n.bannerForm h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.inputField {\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.inputField label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n}\n\n.imageUploadBox {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    text-align: center;\n    cursor: pointer;\n    background: #fafafa;\n    min-height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 255px;\n}\n\n.imageUploadBox.draging {\n    opacity: 70%;\n}\n\n.newpageImageUpload {\n    width: 100%;\n}\n\n.featureImgMiddleContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.fileUploadCover_Img {\n    width: 48px;\n    height: 48px;\n    opacity: 0.6;\n}\n\n.newPageImageUploadText {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n}\n\n.featuredImg {\n    max-width: 100%;\n    max-height: 200px;\n    border-radius: 8px;\n    object-fit: cover;\n    width: 100%;\n}\n\n.progressWrap {\n    width: 100%;\n    height: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.progress {\n    width: 100%;\n    height: 4px;\n    background: #e0e0e0;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.color {\n    height: 100%;\n    background: #000;\n    animation: progress 2s ease-in-out infinite;\n}\n\n@keyframes progress {\n    0% {\n        width: 0%;\n    }\n\n    50% {\n        width: 50%;\n    }\n\n    100% {\n        width: 100%;\n    }\n}\n\n.buttonGroup {\n    margin-bottom: 20px;\n}\n\n.buttonField {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n    margin-top: 8px;\n}\n\n.buttonField input {\n    flex: 1;\n}\n\n.error {\n    color: red;\n    font-size: 14px;\n}\n\n@media screen and (max-width: 768px) {\n\n    .actionButtonsDeleteAdd {\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: 100%;\n        min-width: 100%;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n\n    .buttonField {\n        flex-direction: column;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerDatatableList": `banner_bannerDatatableList__RQSqi`,
	"bannerHeader": `banner_bannerHeader__KJ9na`,
	"imageGroup": `banner_imageGroup__vD+4q`,
	"bannerHeading": `banner_bannerHeading__oWi+n`,
	"actionButtonsDeleteAdd": `banner_actionButtonsDeleteAdd__GNniV`,
	"leftSide": `banner_leftSide__8lrjJ`,
	"searchBar": `banner_searchBar__+gqle`,
	"addBannerContainer": `banner_addBannerContainer__S2tez`,
	"bannerGenerateSection": `banner_bannerGenerateSection__QWJZs`,
	"bannerInput": `banner_bannerInput__te+3a`,
	"description": `banner_description__Cjdnt`,
	"inputField": `banner_inputField__ioiGv`,
	"deleteSelectedBtn": `banner_deleteSelectedBtn__Pr0fr`,
	"saveButton": `banner_saveButton__Gq-Rz`,
	"bannerList": `banner_bannerList__Foz6V`,
	"bannerListHeight": `banner_bannerListHeight__j1p1w`,
	"bannerForm": `banner_bannerForm__nT+dE`,
	"imageUploadBox": `banner_imageUploadBox__EYTqn`,
	"draging": `banner_draging__T0n49`,
	"newpageImageUpload": `banner_newpageImageUpload__J4JY6`,
	"featureImgMiddleContent": `banner_featureImgMiddleContent__WUm7t`,
	"fileUploadCover_Img": `banner_fileUploadCover_Img__D0eGI`,
	"newPageImageUploadText": `banner_newPageImageUploadText__UkNof`,
	"featuredImg": `banner_featuredImg__7gZHI`,
	"progressWrap": `banner_progressWrap__NK2ev`,
	"progress": `banner_progress__NnSN-`,
	"color": `banner_color__8k-Qd`,
	"buttonGroup": `banner_buttonGroup__zIy+s`,
	"buttonField": `banner_buttonField__NcT3p`,
	"error": `banner_error__PfFKT`
};
export default ___CSS_LOADER_EXPORT___;
